const getSectionsToRender = () => {
    return [
        {
            id: '#product-grid',
            replace: false,
        },
        {
            id: '#lb-pagination-control',
            replace: true,
        },
    ];
};

const getSectionInnerHTML = (html, selector) => {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
};

const loadMore = (evt) => {
    evt.preventDefault();
    const url = evt.target.href;
    evt.target.querySelector('span').classList.add('hidden');
    evt.target.classList.add('loading');
    evt.target.querySelector('.loading__spinner').classList.remove('hidden');
    evt.target.disabled = true;
    fetch(url).then(response => response.text()).then(html => {
        getSectionsToRender().forEach(section => {
            debugger;
            const element = document.querySelector(section.id);
            if (section.replace) {
                element.innerHTML = getSectionInnerHTML(html, section.id);
            }
            else {
                element.innerHTML += getSectionInnerHTML(html, section.id);
            }
        });
    });
};

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('lb-paginate-link')) {
            loadMore(evt);
        }
    });
});